import { useParams as useRouterParams } from 'react-router-dom';

type Params<Key extends string = string> = {
  readonly [key: string]: string | undefined;
} & {
  readonly [key in Key]: string;
};
/**
 * Returns an object of key/value pairs of the dynamic params from the current URL that were matched by the route path.
 *
 * Define mandatory params as string signature
 * @example const { foo, bar, baz } = useParams<"foo" | "bar">();
 */
export const useParams = <Key extends string = never>() => {
  const params = useRouterParams<Key>();
  return params as Readonly<Params<Key>>;
};
